// Compact date helper: current year -> "M/D", other years -> "M/D/YY"
export function formatBoardDate(value) {
  if (!value) return "—";
  const asDate = typeof value === "string" ? new Date(`${value}T00:00:00`) : value;
  if (isNaN(asDate.getTime())) return "—";
  const currentYear = new Date().getFullYear();
  const m = asDate.getMonth() + 1;
  const d = asDate.getDate();
  const y = asDate.getFullYear();
  return y === currentYear ? `${m}/${d}` : `${m}/${d}/${String(y).slice(-2)}`;
}
